import { Components, Theme } from '@mui/material/styles'

export const tabsTheme: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    indicator: ({ theme }) => ({
      position: 'absolute',
      height: '.2rem',
      backgroundColor: theme.palette.primary.main,
    }),
    root: ({ theme }) => ({
      backgroundColor: theme.palette.header,
      minHeight: '3.6rem',
    }),
  },
}

export const tabTheme: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: '3.6rem',
      fontWeight: 'bold',
      padding: '0 1.6rem',
      [theme.breakpoints.up('md')]: {
        minWidth: 0,
      },
      '&.Mui-selected': {
        color: theme.palette.text.primary,
      },
    }),
    textColorInherit: ({ theme }) => ({
      color: theme.palette.text.secondary,
    }),
    wrapper: {
      minWidth: 0,
    },
  },
  defaultProps: {
    disableRipple: true,
  },
}
